<template>
  <v-app-bar flat absolute dark color="blue darken-2" class="headerFont pl-3">
    sigflō admin
    <v-spacer></v-spacer>
    <v-btn color="primary" small fab @click="toggleTheme"
      ><v-icon>mdi-invert-colors</v-icon></v-btn
    >
  </v-app-bar>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {};
    },
    computed: {
      ...mapState(['app'])
    },
    methods: {
      toggleTheme() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      }
    }
  };
</script>

<style scoped>
  .headerFont {
    font-size: 48px;
  }
</style>
